import React from 'react';

export const defaultFacets = {
  "theme": {
    "label": "Temas",
    "field": "theme.0.title",
    "showAll": false,
    "limit": 10,
    "reset": {
      "active": false,
      "icon": <span></span>
    },
  },
  "keyword": {
    "label": "Etiquetas",
    "field": "keyword.*.title",
    "showAll": false,
    "limit": 10,
    "reset": {
      "active": false,
      "icon": <span></span>
    },
  },
  "publisher__name": {
    "label": "Autores",
    "field": "publisher__name",
    "showAll": false,
    "limit": 10,
    "reset": {
      "active": false,
      "icon": <span></span>
    },
  },
  // Formato de distribución. Se declara como faceta para que el frontend pida sus
  // conteos al backend (/facets?facets=distribution__item__format) y el
  // FormatFilter muestre la lista dinámica. SearchFacets excluye esta clave del
  // render de facetas estándar (la pinta el FormatFilter, no SearchFacet).
  "distribution__item__format": {
    "label": "Formatos",
    "field": "distribution__item__format",
    "showAll": false,
    "limit": 10,
    "reset": {
      "active": false,
      "icon": <span></span>
    },
  }
}

export function normalizeItems(resultItems) {
  let nItems = resultItems;
  if (!Array.isArray(nItems)) {
    nItems = Object.values(nItems);
  }
  return nItems.map((x) => {
    let item = {};
    item = {
      identifier: x.identifier,
      modified: x.modified,
      // Fecha de publicación (created del nodo); el backend la envía como
      // 'issued'. Se pasa a la tarjeta para poder mostrarla junto a 'modified'.
      issued: x.issued,
      description: x.description,
      theme: x.theme,
      format: x.distribution,
      title: x.title,
      ref: `/dataset/${x.identifier}`
    };
    if (
      Object.prototype.hasOwnProperty.call(x, "publisher") &&
      Object.prototype.hasOwnProperty.call(x.publisher, "name")
    ) {
      item.publisher = x.publisher.name;
    } else {
      item.publisher = "";
    }
    return item;
  });
}

// Opciones de ordenamiento (RF06). Cada `field` se corresponde con una clave de
// SORT_EXPRESSIONS del backend (SearchController):
//   - views     -> contador de visitas (field_visitas)
//   - downloads -> contador de descargas (field_descargas)
//   - created   -> fecha de creación del nodo (= fecha de publicación/alta)
//   - modified  -> fecha de última modificación
//   - title     -> alfabético
// 'search_api_relevance' es la opción por defecto; el índice por DB no calcula
// relevancia, así que el backend la trata como "más recientes" (modified desc).
export const sortOptions = [
  {
    field: 'search_api_relevance',
    order: 'desc',
    label: 'Relevancia'
  },
  {
    field: 'views',
    order: 'desc',
    label: 'Más visto'
  },
  {
    field: 'downloads',
    order: 'desc',
    label: 'Más descargado'
  },
  {
    field: 'created',
    order: 'desc',
    label: 'Fecha de publicación (más reciente)'
  },
  {
    field: 'created',
    order: 'asc',
    label: 'Fecha de publicación (más antigua)'
  },
  {
    field: 'modified',
    order: 'desc',
    label: 'Fecha de última modificación (más reciente)'
  },
  {
    field: 'modified',
    order: 'asc',
    label: 'Fecha de última modificación (más antigua)'
  },
  {
    field: 'title',
    order: 'asc',
    label: 'Alfabéticamente (A-Z)'
  },
  {
    field: 'title',
    order: 'desc',
    label: 'Alfabéticamente (Z-A)'
  }
];
